// extracted by mini-css-extract-plugin
export default {"titlefont":"titletop_titlefont__nxdYn","subtitle":"titletop_subtitle__duM1u","greenbutton":"titletop_greenbutton__XhZJ-","opac":"titletop_opac__8+vLp","img":"titletop_img__3TS39"};